export default "__VITE_ASSET__374BfhX7__"